<template>
    <Teleport to="#slide-overs" v-if="show">
        <div class="fixed z-10 inset-0 overflow-hidden">
            <div class="absolute inset-0 overflow-hidden">
                <div
                    @click="dismiss()"
                    class="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    aria-hidden="true"
                    v-show="show"
                ></div>
                <section class="absolute inset-y-0 right-0 pl-10 max-w-full flex" aria-labelledby="slide-over-heading">
                    <transition
                        enter-active-class="transform transition ease-in-out duration-500 sm:duration-700"
                        enter-from-class="translate-x-full"
                        enter-to-class="translate-x-0"
                        leave-active-class="transform transition ease-in-out duration-500 sm:duration-700"
                        leave-from-class="translate-x-0"
                        leave-to-class="translate-x-full"
                    >
                        <div class="relative w-screen" :class="sizeClass" v-show="show">
                            <transition
                                enter-active-class="ease-in-out duration-500"
                                enter-from-class="opacity-0"
                                enter-to-class="opacity-100"
                                leave-active-class="ease-in-out duration-500"
                                leave-from-class="opacity-100"
                                leave-to-class="opacity-0"
                            >
                                <div class="absolute top-0 left-0 -ml-8 pt-4 pr-2 flex sm:-ml-10 sm:pr-4" v-show="show">
                                    <button
                                        class="rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                        @click="dismiss()"
                                    >
                                        <span class="sr-only">Close panel</span>
                                        <!-- Heroicon name: outline/x -->
                                        <svg
                                            class="h-6 w-6"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            aria-hidden="true"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M6 18L18 6M6 6l12 12"
                                            />
                                        </svg>
                                    </button>
                                </div>
                            </transition>
                            <div class="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
                                <div class="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
                                    <div class="px-4 sm:px-6">
                                        <div class="flex items-start justify-between">
                                            <h2
                                                class="text-base font-semibold leading-6 text-gray-900"
                                                id="slide-over-title"
                                            >
                                                {{ title }}
                                            </h2>
                                        </div>
                                    </div>
                                    <div
                                        class="relative mt-6 flex-1 px-4 sm:px-6"
                                        :class="{
                                            'border-2 border-dashed border-gray-200': dashed,
                                        }"
                                    >
                                        <slot></slot>
                                    </div>
                                </div>
                                <div class="flex flex-shrink-0 justify-end px-4 py-4">
                                    <slot name="bottom"></slot>
                                </div>
                            </div>
                        </div>
                    </transition>
                </section>
            </div>
        </div>
    </Teleport>
</template>

<script>
export default {
    emits: ['close'],

    props: {
        show: {
            type: Boolean,
            required: true,
        },
        dashed: {
            type: Boolean,
            required: false,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'md',
        },
    },

    data() {
        return {
            sizeClass: {
                'max-w-md': this.size === 'md',
                'max-w-lg': this.size === 'lg',
                'max-w-xl': this.size === 'xl',
                'max-w-2xl': this.size === 'xxl',
                'max-w-3xl': this.size === 'xxxl',
                'max-w-5xl': this.size === 'xxxxxl',
            },
        };
    },

    watch: {
        show: {
            immediate: true,
            handler: function () {},
        },
    },

    methods: {
        dismiss() {
            this.$emit('close');
        },
        onEscape(e) {
            if (e.key === 'Esc' || e.key === 'Escape') {
                this.open = false;
                this.dismiss();
            }
        },
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.onEscape);
    },
    mounted() {
        document.addEventListener('keydown', this.onEscape);
    },
};
</script>
